

import { Component, Vue } from 'vue-property-decorator';
import { DataTableHeader } from 'vuetify';
import InternalTicketsRepositoryInterface, { Ticket, TicketType } from '@/services/Internal-Tickets/interfaces';
import AddBug from '@/views/pages/internal-tickets/AddBug.vue';
import Utils from '@/services/Internal-Tickets/utils';

@Component({
  components: { AddBug },
  inject: ['internalTicketsRepository'],
})
export default class BugList extends Vue {
  public loading: boolean = true;
  public type = TicketType.BUG;

  public bugs: Ticket[] = [];
  public data: any[] = [];
  public search: string = ''

  public readonly internalTicketsRepository: InternalTicketsRepositoryInterface;

  public headers: DataTableHeader[] = [
    { text: 'Title', value: 'title' },
    { text: 'Assignee', value: 'assignee.username' },
    { text: 'Reporter', value: 'reporter' },
    { text: 'Date&Time', value: 'createdAt' },
    { text: 'priority', value: 'priority.name', sortable: false },
    { text: 'status', value: 'status.name', sortable: false },
  ];

  public async mounted(): Promise<void> {
    await this.initialize();
    this.loading = false;
  }

  public async initialize(): Promise<void> {
    this.bugs = await this.getBugs();
    this.bugs = await Utils.transformUserIdsToNames(this.bugs, this.internalTicketsRepository);
  }

  public formatDate(timestamp: string) {
    const date = new Date(timestamp);
    return date.toLocaleString(); // returns a string in the format "4/4/2023, 3:04:36 PM" (based on the user's browser settings)
  }


  public async getBugs(): Promise<Ticket[]> {
    try {
      return this.internalTicketsRepository.getBugs();
    } catch (e) {
      this.$errorDialog.show('Failed to retrieve bugs: ' + e.message);
      return [];
    }
  }

  public async refresh() {
    this.bugs = await this.getBugs()
  }
}
